import React from "react";
import Table from "react-bootstrap/Table";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import Nav from "./Nav";
import PaginationBar from "./PaginationBar";
import ContaxtMenu from "./Contaxtmenu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import moment from "moment";

var oldData = [];
var hiddenColumnsBackup = [];
export default class DataTable extends React.Component {
  constructor(props) {
    super(props);
    console.log(props.data);
    this.state = {
      rowdata: [],
      isTableDataFound: false,
      clickedSortColumn: "",
      clickedOriginalColumn: "",
      sortColumnKey: "",
      showContaxtMenu: false,
      currentClickedColumn: "",
      currentClickedColumnIndex: "",
      fixedStyle: "",
      freezed: false,
      lastSelectedColumnIndex: "",
      sortType: "",
      sorted: false,
      hiddenColumns: [],
      showPaginationRows: 0,
      currentPaginationPage: 0,
      clickedRow: -1,
      cellDensity: "5px",
    };
    this.getHeader = this.getHeader.bind(this);
    this.getRowsData = this.getRowsData.bind(this);
    this.getKeys = this.getKeys.bind(this);
    this.checkSpace = this.checkSpace.bind(this);
    this.getSortIcons = this.getSortIcons.bind(this);
    this.checkFixedColumns = this.checkFixedColumns.bind(this);
    this.setDate = this.setDate.bind(this);
  }

  componentDidMount() {
    if (this.props.data != undefined && this.props.data.length > 0) {
      oldData = this.props.data;
      this.setState({
        rowdata: this.props.data,
        isTableDataFound: true,
      });
    }
    if (this.props.pagination != undefined) {
      this.setState({ showPaginationRows: this.props.pagination.rowsPerPage });
    }
  }

  getKeys(data) {
    if (data != undefined && data != null) {
      return Object.keys(data);
    }
  }

  checkSpace(element) {
    if (element.indexOf(" ") > -1) {
      return element.replaceAll(" ", "").toLowerCase();
    } else {
      return element.toLowerCase();
    }
  }

  getSortIcons(key, sortKey, sortType, originalKey) {
    // console.log(key,sortObj.name) {function arguments are key, sortObj for multiple sort columns}
    const isHTML = (str) => {
      var a = document.createElement("div");
      a.innerHTML = str;
      for (var c = a.childNodes, i = c.length; i--; ) {
        if (c[i].nodeType == 1) return true;
      }
      return false;
    };
    const filter = (name, sortType) => {
      console.log(name);
      if (sortType == "asc") {
        return (
          <ArrowDropUpIcon
            style={{ cursor: "pointer" }}
            onClick={() => {
              // copy your state.data to a new array and sort it by name in ascending order
              const myData = [].concat(oldData);
              this.setState({
                rowdata: myData.sort((a, b) => {
                  if (!isHTML(a[`${name}`]) && !isHTML(b[`${name}`])) {
                    if (
                      typeof a[`${name}`] == "number" &&
                      typeof b[`${name}`] == "number"
                    ) {
                      return b[`${name}`] - a[`${name}`];
                    } else {
                      return b[`${name}`] > a[`${name}`] ? 1 : -1;
                    }
                  } else {
                    const first = a[`${name}`].replace(/<[^>]+>/g, "");
                    const second = b[`${name}`].replace(/<[^>]+>/g, "");
                    if (typeof first == "number" && typeof second == "number") {
                      return second - first;
                    } else {
                      return second > first ? 1 : -1;
                    }
                  }
                }),
                sortType: "desc",
              });
            }}
          />
        );
      } else if (sortType == "desc") {
        return (
          <ArrowDropDownIcon
            style={{ cursor: "pointer" }}
            onClick={() => {
              const myData = [].concat(oldData);
              this.setState({
                rowdata: myData.sort((a, b) => {
                  if (!isHTML(a[`${name}`]) && !isHTML(b[`${name}`])) {
                    if (
                      typeof a[`${name}`] == "number" &&
                      typeof b[`${name}`] == "number"
                    ) {
                      return a[`${name}`] - b[`${name}`];
                    } else {
                      return a[`${name}`] > b[`${name}`] ? 1 : -1;
                    }
                  } else {
                    const first = a[`${name}`].replace(/<[^>]+>/g, "");
                    const second = b[`${name}`].replace(/<[^>]+>/g, "");
                    if (typeof first == "number" && typeof second == "number") {
                      return first - second;
                    } else {
                      return first > second ? 1 : -1;
                    }
                  }
                }),
                sortType: "asc",
              });
            }}
          />
        );
      } else {
        return;
      }
    };
    if (this.checkSpace(key) == this.checkSpace(sortKey)) {
      return filter(originalKey, sortType);
    }
  }

  checkFixedColumns(fixedColumns, newColName) {
    // console.log(fixedColumns,newColName)
    if (fixedColumns != undefined) {
      if (fixedColumns.indexOf(",") > -1) {
        return fixedColumns.split(",").map((col) => {
          if (col == newColName) {
            return {
              position: "sticky",
              left: "-1px",
              background: "#d8d0d0",
              border: "1px solid #000",
            };
          } else {
            return { border: "1px solid #000" };
          }
        });
      } else {
        if (fixedColumns == newColName) {
          return {
            position: "sticky",
            left: "-1px",
            background: "#d8d0d0",
            border: "1px solid #000",
          };
        } else {
          return { border: "1px solid #000" };
        }
      }
    }
  }

  getHeader(data, showColumns, isUpperCase, replaceColumns, AddColumns) {
    // console.log(replaceColumns)
    var keys = this.getKeys(data[0]);
    let lastIndexOfFreezedColumn = this.state.currentClickedColumnIndex;
    const setColumnFix = (lastIndex, currentIndex) => {
      if (this.state.freezed == true && currentIndex <= lastIndex) {
        console.log(this.state.showContaxtMenu);
        let left = 0;
        for (let i = 0; i < currentIndex; i++) {
          left +=
            document.getElementById("mydataTable").rows[0].cells[i].offsetWidth;
        }
        console.log(left);
        return Object.assign(
          { position: "sticky", left: left },
          this.props.inputProps.thead
        );
      }
    };

    if (showColumns.length > 0) {
      if (AddColumns != undefined && AddColumns.length > 0) {
        for (let i = 0; i < AddColumns.length; i++) {
          let colName = AddColumns[i].name,
            position = AddColumns[i].position;
          if (position == "start" && !keys.includes(colName)) {
            showColumns.unshift(colName);
            keys.unshift(colName);
          } else if (position == "end" && !keys.includes(colName)) {
            showColumns.push(colName);
            keys.push(colName);
          }
          console.log(keys);
        }
      }
      let newColumnNamesArr = showColumns.filter((element) => {
        return keys.includes(this.checkSpace(element));
      });
      console.log(newColumnNamesArr);
      return newColumnNamesArr.map((key, index) => {
        let displayKey = key;
        let originalKey = key;
        if (replaceColumns != undefined && replaceColumns.length > 0) {
          for (let i = 0; i < replaceColumns.length; i++) {
            if (replaceColumns[i].name.toLowerCase() == displayKey) {
              displayKey = replaceColumns[i].with.toLowerCase();
            }
          }
        }
        return (
          <th
            key={displayKey}
            style={setColumnFix(lastIndexOfFreezedColumn, index)}
            onMouseEnter={() => {
              document.getElementById(
                displayKey + "contextBtn"
              ).style.visibility = "visible";
            }}
            onMouseLeave={() => {
              document.getElementById(
                displayKey + "contextBtn"
              ).style.visibility = "hidden";
            }}
            onContextMenu={(e) => {
              e.preventDefault();
              this.setState({
                showContaxtMenu: true,
                clickedOriginalColumn: originalKey,
                currentClickedColumn: displayKey,
                lastSelectedColumnIndex: index,
              });
            }}
          >
            <div
              style={{
                minHeight: "25px",
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <span>
                {isUpperCase ? displayKey.toUpperCase() : displayKey}
                &nbsp;
                {this.state.sortColumnKey &&
                  this.getSortIcons(
                    displayKey,
                    this.state.sortColumnKey,
                    this.state.sortType,
                    originalKey
                  )}
              </span>
              <MoreVertIcon
                id={displayKey + "contextBtn"}
                style={{ visibility: "hidden", cursor: "pointer" }}
                onClick={() =>
                  this.setState({
                    showContaxtMenu: true,
                    clickedOriginalColumn: originalKey,
                    currentClickedColumn: displayKey,
                    lastSelectedColumnIndex: index,
                  })
                }
              />
            </div>
          </th>
        );
      });
    } else {
      if (AddColumns != undefined && AddColumns.length > 0) {
        for (let i = 0; i < AddColumns.length; i++) {
          let colName = AddColumns[i].name,
            position = AddColumns[i].position;
          if (position == "start" && !keys.includes(colName)) {
            keys.unshift(colName);
          } else if (position == "end" && !keys.includes(colName)) {
            keys.push(colName);
          }
        }
      }

      // This code is for removing hidden keys from table headers
      if (this.state.hiddenColumns.length > 0) {
        for (const hiddenKey of this.state.hiddenColumns) {
          keys = keys.filter(
            (key) => key.toLowerCase() != hiddenKey.toLowerCase()
          );
        }
      }
      console.log(this.state.hiddenColumns, keys);

      return keys.map((key, index) => {
        let displayKey = key;
        let originalKey = key;
        if (replaceColumns != undefined && replaceColumns.length > 0) {
          for (let i = 0; i < replaceColumns.length; i++) {
            if (replaceColumns[i].name.toLowerCase() == displayKey) {
              displayKey = replaceColumns[i].with.toLowerCase();
            }
          }
        }
        return (
          <th
            key={displayKey}
            style={setColumnFix(lastIndexOfFreezedColumn, index)}
            onMouseEnter={() => {
              document.getElementById(
                displayKey + "contextBtn"
              ).style.visibility = "visible";
            }}
            onMouseLeave={() => {
              document.getElementById(
                displayKey + "contextBtn"
              ).style.visibility = "hidden";
            }}
            onContextMenu={(e) => {
              e.preventDefault();
              this.setState({
                showContaxtMenu: true,
                clickedOriginalColumn: originalKey,
                currentClickedColumn: displayKey,
                lastSelectedColumnIndex: index,
              });
            }}
          >
            <div
              style={{
                minHeight: "25px",
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <span>
                {isUpperCase ? displayKey.toUpperCase() : displayKey}
                &nbsp;
                {this.state.sortColumnKey &&
                  this.getSortIcons(
                    displayKey,
                    this.state.sortColumnKey,
                    this.state.sortType,
                    originalKey
                  )}
              </span>
              <MoreVertIcon
                id={displayKey + "contextBtn"}
                style={{ visibility: "hidden", cursor: "pointer" }}
                onClick={() =>
                  this.setState({
                    showContaxtMenu: true,
                    clickedOriginalColumn: originalKey,
                    currentClickedColumn: displayKey,
                    lastSelectedColumnIndex: index,
                  })
                }
              />
            </div>
          </th>
        );
      });
    }
  }

  getRowsData(tabledata, showColumns, AddColumns) {
    let lastIndexOfFreezedColumn = this.state.currentClickedColumnIndex;
    const setColumnFix = (lastIndex, currentIndex) => {
      if (this.state.freezed == true && currentIndex <= lastIndex) {
        let left = 0;
        for (let i = 0; i < currentIndex; i++) {
          left +=
            document.getElementById("mydataTable").rows[0].cells[i].offsetWidth;
        }
        return {
          position: "sticky",
          left: left,
          background: "#fff",
          boxShadow:
            currentIndex == lastIndex
              ? " inset -4px 0px 0px -1px #ABABAB"
              : " inset 0px 0px 0px -1px #ABABAB",
        };
      } else {
        return { padding: this.state.cellDensity };
      }
    };
    //     ,{padding:this.state.cellDensity}
    // ,{padding:this.state.cellDensity}
    // ,{padding:this.state.cellDensity}
    const jsxPart = (value, colIndex, newColName) => {
      if (value == null) {
        value = "";
      }
      if (typeof value != "object") {
        return (
          <td
            key={colIndex}
            style={setColumnFix(lastIndexOfFreezedColumn, colIndex)}
            dangerouslySetInnerHTML={{ __html: value }}
          ></td>
        );
      } else if (React.isValidElement(value)) {
        return (
          <td
            key={colIndex}
            style={setColumnFix(lastIndexOfFreezedColumn, colIndex)}
          >
            {value}
          </td>
        );
      } else {
        return (
          <td
            key={colIndex}
            style={setColumnFix(lastIndexOfFreezedColumn, colIndex)}
            dangerouslySetInnerHTML={{ __html: this.setDate(value.date) }}
          ></td>
        );
      }
    };
    var newTableData = [].concat(tabledata);
    if (AddColumns != undefined && AddColumns.length > 0) {
      let temp_arr = newTableData;
      for (let index = 0; index < temp_arr.length; index++) {
        let row = temp_arr[index],
          columns = Object.keys(row);

        for (let j = 0; j < columns.length; j++) {
          for (let i = 0; i < AddColumns.length; i++) {
            let position = AddColumns[i].position,
              cellValue = AddColumns[i].cellValue,
              key = AddColumns[i].name;
            if (position == "start" && j == 0) {
              let obj = {};
              obj[`${key}`] = cellValue;
              obj = { ...obj, ...newTableData[index] };
              // newTableData.unshift()
              newTableData[index] = obj;
              // console.log(obj)
            }
            if (position == "end" && j == columns.length - 1) {
              let obj = {};
              obj[`${key}`] = cellValue;
              obj = { ...newTableData[index], ...obj };
              // temp_arr_copy.push(obj)
              newTableData[index] = obj;
              // console.log(obj)
            }
          }
        }
      }
    }

    // This code is for removing hidden keys from table headers
    if (this.state.hiddenColumns.length > 0) {
      let filterArray = [];
      let keys = this.state.hiddenColumns;
      for (let i = 0; i < newTableData.length; i++) {
        let columns = Object.keys(newTableData[i]);
        let filterObj = {};
        for (const key of columns) {
          if (!keys.includes(key.toLowerCase())) {
            // console.log(key)
            filterObj[key] = newTableData[i][key];
          }
        }
        filterArray.push(filterObj);
      }
      console.log(this.state.hiddenColumns, filterArray);
      newTableData = filterArray;
    }
    let newData = newTableData;
    if (this.props.pagination != undefined && this.props.pagination.show) {
      newData = newTableData.filter((row, index) => {
        let rowPerPage =
          this.state.showPaginationRows < 0
            ? newTableData.length
            : this.state.showPaginationRows;
        let start = this.state.currentPaginationPage * rowPerPage;
        let end = (this.state.currentPaginationPage + 1) * rowPerPage;
        if (index >= start && index < end) return true;
      });
      console.log(newData, this.state.currentPaginationPage);
    }
    return (
      <>
        {newData.map((row, rowIndex) => {
          var entity = this.getKeys(row);
          if (showColumns.length > 0) {
            let newColumnNamesArr = showColumns.filter((element) => {
              return entity.includes(this.checkSpace(element));
            });
            return (
              <tr
                key={rowIndex}
                style={{
                  cursor: "pointer",
                  backgroundColor:
                    this.state.clickedRow == rowIndex ? "rgba(0,0,0,0.08)" : "",
                }}
                onClick={() =>
                  this.props.onRowClick &&
                  this.setState({ clickedRow: rowIndex }, () =>
                    this.props.onRowClick(row)
                  )
                }
              >
                {newColumnNamesArr.map((colName, colIndex) => {
                  let newColName = colName.replaceAll(" ", "").toLowerCase();
                  return jsxPart(row[newColName], colIndex, newColName);
                })}
              </tr>
            );
          } else {
            return (
              <tr
                key={rowIndex}
                style={{
                  cursor: "pointer",
                  backgroundColor:
                    this.state.clickedRow == rowIndex ? "rgba(0,0,0,0.08)" : "",
                  padding: "60px 0px",
                }}
                onClick={(e) =>
                  this.props.onRowClick &&
                  this.setState({ clickedRow: rowIndex }, () =>
                    this.props.onRowClick(row)
                  )
                }
              >
                {entity.map((colName, colIndex) => {
                  return jsxPart(row[colName], colIndex, colName);
                })}
              </tr>
            );
          }
        })}
      </>
    );
  }

  storeSearch(value) {
    // this.setState({ isSearchValue: true, search: e.target.value })
    let applyFilter = [];
    if (this.props.navbar.searchOnKeys.length > 0) {
      applyFilter = this.props.navbar.searchOnKeys;
    } else {
      applyFilter = Object.keys(oldData[0]);
    }
    // if (this.props.navbar.searchOnKeys.indexOf(',') > -1) {
    //   applyFilter = this.props.navbar.searchOnKeys.split(',')
    //   // for(let i=0;i<headers.length;i++){
    //   //   applyFilter += headers[i].toLowerCase()+' '
    //   // }
    // } else {
    //   applyFilter = this.props.navbar.searchOnKeys.toLowerCase()
    // }

    // let applyFilter = this.props.searchOnKeys.join(' ')
    // console.log(applyFilter, this.state.rowdata)
    if (value == "") {
      if (oldData.length > 0) {
        this.setState({ rowdata: oldData, isTableDataFound: true });
      } else {
        this.setState({ isTableDataFound: false });
      }
    } else {
      if (
        oldData.filter((data) => {
          if (Array.isArray(applyFilter)) {
            let StrArr = [];
            for (let i = 0; i < applyFilter.length; i++) {
              StrArr.push(data[`${applyFilter[i].toLowerCase()}`]);
            }
            return StrArr.join(" ")
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase());
          } else {
            return data[`${applyFilter[0].toLowerCase()}`]
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase());
          }
        }).length > 0
      ) {
        this.setState(
          {
            rowdata: oldData.filter((data) => {
              if (Array.isArray(applyFilter)) {
                let StrArr = [];
                for (let i = 0; i < applyFilter.length; i++) {
                  StrArr.push(data[`${applyFilter[i].toLowerCase()}`]);
                }
                return StrArr.join(" ")
                  .toString()
                  .toLowerCase()
                  .includes(value.toLowerCase());
              } else {
                return data[`${applyFilter[0].toLowerCase()}`]
                  .toString()
                  .toLowerCase()
                  .includes(value.toLowerCase());
              }
            }),
            isTableDataFound: true,
          },
          () => {
            // if (this.state.rowdata.length < this.props.pagination.rowsPerPage) {
            this.setState({ currentPaginationPage: 0 });
            // console.log(this.props.pagination.rowsPerPage)
            console.log("=============================");
            console.log(this.state.rowdata.length);
            console.log("=============================");
            console.log(this.state.currentPaginationPage);
            // }
          }
        );
      } else {
        console.log("sdflksdfl");
        this.setState({ isTableDataFound: false });
      }
    }
  }

  onClearSearch() {
    if (oldData.length > 0) {
      this.setState({ rowdata: oldData, isTableDataFound: true });
    } else {
      this.setState({ rowdata: [], isTableDataFound: false });
    }
  }
  setDate(date) {
    if (date != undefined) {
      return date.split(".")[0];
    }
  }
  onTableDownload(option) {
    let fileName = "Table";
    if (this.props.navbar.heading != undefined) {
      fileName = this.props.navbar.heading;
    }
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();
    var hrs = String(today.getHours()).padStart(2, "0");
    var mins = String(today.getMinutes()).padStart(2, "0");
    var newfilename = `${fileName}_${yyyy}${mm}${dd}_${hrs}${mins}`;
    if (fileName.indexOf(" ") > -1) {
      newfilename = `${fileName.replaceAll(
        " ",
        "_"
      )}_${yyyy}${mm}${dd}_${hrs}${mins}`;
    }
    var tabledata = [];

    // // Downloading table into PDF
    if (option.toLowerCase() == "pdf") {
      let finalPDFdataArray = [],
        finalPDFdataHead = [];
      this.state.rowdata.map((s, index) => {
        // console.log(s)
        var datakeys = Object.keys(s);
        let AddColumns = this.props.AddColumns;
        if (AddColumns != undefined && AddColumns.length > 0) {
          for (let colKey of datakeys) {
            for (let i = 0; i < AddColumns.length; i++) {
              let data = AddColumns[i];
              if (data["name"] == colKey) {
                // console.log(colKey)
                datakeys = datakeys.filter((el) => {
                  return el.toLowerCase() !== colKey.toLowerCase();
                });
              }
            }
          }
        }
        // console.log(datakeys)
        let newArr = [];
        finalPDFdataHead = datakeys;
        for (const key of datakeys) {
          if (typeof s[key] == "null") {
            s[key] = "";
          }
          if (typeof s[key] == "object") {
            newArr.push(this.setDate(s[key]["date"]));
          } else {
            newArr.push(s[key]);
          }
        }
        finalPDFdataArray.push(newArr);
      });

      const unit = "pt";
      const size = "A4";
      const orientation = "landscape";

      const doc = new jsPDF(orientation, unit, size);
      // var startingPage = doc.internal.getCurrentPageInfo().pageNumber;
      // doc.setPage(startingPage);
      doc.autoTable({
        head: [finalPDFdataHead],
        body: finalPDFdataArray,
        styles: {
          overflow: "linebreak",
          columnWidth: "wrap",
        },
        margin: { horizontal: 10, vertical: 20 },
        // bodyStyles: { valign: 'top' },
        horizontalPageBreak: true,
        // columnStyles: { text: { columnWidth: 'auto' } }
      });
      doc.save("table.pdf");
    }

    // // Downloading table into Microsoft-Excel

    if (option.toLowerCase() == "excel") {
      this.state.rowdata.map((s, index) => {
        // console.log(s)
        var datakeys = Object.keys(s);
        let AddColumns = this.props.AddColumns;
        if (AddColumns != undefined && AddColumns.length > 0) {
          for (let colKey of datakeys) {
            for (let i = 0; i < AddColumns.length; i++) {
              let data = AddColumns[i];
              if (data["name"] == colKey) {
                // console.log(colKey)
                datakeys = datakeys.filter((el) => {
                  return el.toLowerCase() !== colKey.toLowerCase();
                });
              }
            }
          }
        }
        // console.log(datakeys)
        var obj = {};
        // for (var i = 0; i < datakeys.length; i++) {

        // }
        for (const key of datakeys) {
          if (typeof s[key] == "null") {
            s[key] = "";
          }
          if (typeof s[key] == "object") {
            obj[key] = this.setDate(s[key]["date"]);
          } else {
            obj[key] = s[key];
          }
        }
        tabledata.push(obj);
      });
      console.log(tabledata);
      let updatedTableData = {
        "Sheet 1": tabledata,
      };
      console.log(updatedTableData);

      if (document.getElementById("tabledata")) {
        document.getElementById("tabledata").value =
          JSON.stringify(updatedTableData);
        document.getElementById("filename").value = newfilename;
        document.getElementById("ExcelExport").click();
      }
    }
  }
  onSortChange(order, isSorted) {
    const isHTML = (str) => {
      var a = document.createElement("div");
      a.innerHTML = str;
      for (var c = a.childNodes, i = c.length; i--; ) {
        if (c[i].nodeType == 1) return true;
      }
      return false;
    };
    let name = this.state.clickedOriginalColumn;
    if (order == "asc") {
      const myData = [].concat(oldData);
      this.setState({
        rowdata: myData.sort((a, b) => {
          if (!isHTML(a[`${name}`]) && !isHTML(b[`${name}`])) {
            if (
              typeof a[`${name}`] == "number" &&
              typeof b[`${name}`] == "number"
            ) {
              return a[`${name}`] - b[`${name}`];
            } else {
              return a[`${name}`] > b[`${name}`] ? 1 : -1;
            }
          } else {
            const first = a[`${name}`].replace(/<[^>]+>/g, "");
            const second = b[`${name}`].replace(/<[^>]+>/g, "");
            if (typeof first == "number" && typeof second == "number") {
              return first - second;
            } else {
              return first > second ? 1 : -1;
            }
          }
        }),
      });
    } else if (order == "desc") {
      const myData = [].concat(oldData);
      this.setState({
        rowdata: myData.sort((a, b) => {
          if (!isHTML(a[`${name}`]) && !isHTML(b[`${name}`])) {
            if (
              typeof a[`${name}`] == "number" &&
              typeof b[`${name}`] == "number"
            ) {
              return b[`${name}`] - a[`${name}`];
            } else {
              return b[`${name}`] > a[`${name}`] ? 1 : -1;
            }
          } else {
            const first = a[`${name}`].replace(/<[^>]+>/g, "");
            const second = b[`${name}`].replace(/<[^>]+>/g, "");
            if (typeof first == "number" && typeof second == "number") {
              return second - first;
            } else {
              return second > first ? 1 : -1;
            }
          }
        }),
      });
    } else {
      this.setState({ rowdata: oldData, sortType: "" });
    }
    this.setState({
      sorted: isSorted,
      sortColumnKey: this.state.currentClickedColumn,
      sortType: order,
      showContaxtMenu: false,
    });
  }
  onContaxtMenuSelect(list, isFreeze) {
    this.setState({
      freezed: isFreeze,
      showContaxtMenu: false,
      currentClickedColumnIndex: this.state.lastSelectedColumnIndex,
    });
  }
  onHideColumn() {
    let clickedColumn = this.state.currentClickedColumn.toLowerCase();
    // Check that if any column name is replaced with key
    // if replaced then change the clickedColumn to that replaced original key name
    if (
      this.props.replaceColumns != undefined &&
      this.props.replaceColumns.length > 0
    ) {
      try {
        this.props.replaceColumns.forEach((obj) => {
          if (obj.with.toLowerCase() == clickedColumn) {
            console.log(obj.with, obj.name);
            clickedColumn = obj.name.toLowerCase();
          }
        });
      } catch {
        console.error("replaceColumns array error");
      }
    }
    console.log(clickedColumn);
    if (
      this.state.hiddenColumns.length > 0 &&
      this.state.hiddenColumns.includes(clickedColumn)
    ) {
      this.setState({ hidden: true, showContaxtMenu: false });
    } else {
      let hiddenCols = [...this.state.hiddenColumns, clickedColumn];
      hiddenColumnsBackup = hiddenCols;
      this.setState({
        hiddenColumns: hiddenCols,
        hidden: true,
        showContaxtMenu: false,
      });
    }
  }
  onShowColumn() {
    this.setState({ hiddenColumns: [], hidden: false });
    // this.setState({ hiddenColumns: [], hidden: false, showContaxtMenu: false })
  }

  onSingleColumnShow(title) {
    console.log(this.state.hiddenColumns, title);
    let newArr = this.state.hiddenColumns.filter(
      (col) => col.toLowerCase() != title.toLowerCase()
    );
    hiddenColumnsBackup = newArr;
    this.setState({ hiddenColumns: newArr });
  }
  onSingleColumnHide(title) {
    hiddenColumnsBackup = [...this.state.hiddenColumns, title];
    this.setState({ hiddenColumns: [...this.state.hiddenColumns, title] });
  }
  onHideAllColumns(allHiddenKeys) {
    this.setState({ hiddenColumns: allHiddenKeys });
  }
  onApplyFilter(title, operation, value) {
    if (operation.toLowerCase() == "containing") {
      this.setState({
        rowdata: oldData.filter((data) =>
          data[title].toString().includes(value.trim())
        ),
      });
    } else if (operation.toLowerCase() == "not containing") {
      this.setState({
        rowdata: oldData.filter(
          (data) => !data[title].toString().includes(value.trim())
        ),
      });
    } else if (operation.toLowerCase() == "ending with") {
      this.setState({
        rowdata: oldData.filter((data) =>
          data[title].toString().endsWith(value.trim())
        ),
      });
    } else if (operation.toLowerCase() == "not ending with") {
      this.setState({
        rowdata: oldData.filter(
          (data) => !data[title].toString().endsWith(value.trim())
        ),
      });
    } else if (operation.toLowerCase() == "starting with") {
      this.setState({
        rowdata: oldData.filter((data) =>
          data[title].toString().startsWith(value.trim())
        ),
      });
    } else if (operation.toLowerCase() == "not starting with") {
      this.setState({
        rowdata: oldData.filter((data) =>
          data[title].toString().startsWith(value.trim())
        ),
      });
    } else if (operation.toLowerCase() == "equal to") {
      this.setState({
        rowdata: oldData.filter(
          (data) => data[title].toString() == value.trim()
        ),
      });
    } else if (operation.toLowerCase() == "not equal to") {
      this.setState({
        rowdata: oldData.filter(
          (data) => data[title].toString() != value.trim()
        ),
      });
    }
    setTimeout(() => {
      if (this.state.rowdata.length > 0) {
        this.setState({ isTableDataFound: true });
      } else {
        this.setState({ isTableDataFound: false });
      }
    }, 100);
  }
  onClearFilter() {
    this.setState({ rowdata: oldData });
  }
  onDensitySelect(value) {
    console.log(value);
    if (value == 1) {
      this.setState({ cellDensity: "5px" });
    }
    if (value == 2) {
      this.setState({ cellDensity: "15px 0px" });
    }
    if (value == 3) {
      this.setState({ cellDensity: "30px 0px" });
    }
  }
  render() {
    var showColumns = [];
    if (this.props.cols != undefined) {
      showColumns = this.props.cols;
    }
    return (
      <>
        <div id={this.props.customId}>
          {this.props.navbar && this.props.navbar.downloadUrl && (
            <form
              action={this.props.navbar.downloadUrl}
              method="POST"
              style={{ display: "none" }}
            >
              <input type="hidden" id="tabledata" name="tabledata" />
              <input type="hidden" id="filename" name="filename" />
              <button type="submit" id="ExcelExport" />
            </form>
          )}
          {this.props.navbar && (
            <Nav
              navbar={this.props.navbar}
              isTableDataFound={this.state.isTableDataFound}
              columns={this.state.rowdata}
              onSearchChange={this.storeSearch.bind(this)}
              onClearSearch={this.onClearSearch.bind(this)}
              onDownload={this.onTableDownload.bind(this)}
              onApplyFilter={this.onApplyFilter.bind(this)}
              onClearFilter={this.onClearFilter.bind(this)}
              onDensitySelect={this.onDensitySelect.bind(this)}
            />
          )}
          <Table
            id="mydataTable"
            className={"table-hover"}
            responsive
            style={{ overflow: "auto" }}
          >
            <thead
              style={Object.assign(
                {
                  whiteSpace: "nowrap",
                  position: "sticky",
                  top: "0px",
                  left: "0px",
                  zIndex: "1",
                },
                this.props.inputProps.thead
              )}
            >
              <tr>
                {this.getHeader(
                  this.props.data,
                  showColumns,
                  this.props.uppercase,
                  this.props.replaceColumns,
                  this.props.AddColumns
                )}
              </tr>
            </thead>
            {this.state.isTableDataFound ? (
              this.state.rowdata.length > 0 && (
                <tbody>
                  {this.getRowsData(
                    this.state.rowdata,
                    showColumns,
                    this.props.AddColumns
                  )}
                </tbody>
              )
            ) : (
              <div
                style={{
                  borderTop: "none",
                  zIndex: "-1",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%,-50%)",
                }}
              >
                <h5 style={{ color: "orange" }}>No Data</h5>
              </div>
            )}
          </Table>

          {this.props.pagination && this.props.pagination.show
            ? this.state.isTableDataFound && (
                <PaginationBar
                  rowsPerPage={this.props.pagination.rowsPerPage}
                  count={this.state.rowdata.length}
                  rowsPerPageOptions={this.props.pagination.rowsPerPageOptions}
                  onPageChange={(currentPage) =>
                    this.setState({ currentPaginationPage: currentPage })
                  }
                  onRowsChange={(rows) =>
                    this.setState({
                      showPaginationRows: rows,
                      currentPaginationPage: 0,
                    })
                  }
                />
              )
            : null}

          {this.state.showContaxtMenu ? (
            <ContaxtMenu
              show={this.state.showContaxtMenu}
              currentClickedColumn={this.state.currentClickedColumn}
              onHide={() => this.setState({ showContaxtMenu: false })}
              onSelect={this.onContaxtMenuSelect.bind(this)}
              freezed={this.state.freezed}
              onSortChange={this.onSortChange.bind(this)}
              sorted={this.state.sorted}
              onHideColumn={this.onHideColumn.bind(this)}
              onShowAllColumn={this.onShowColumn.bind(this)}
              hidden={this.state.hidden}
              hiddenColumnsArr={this.state.hiddenColumns}
              onColShow={this.onSingleColumnShow.bind(this)}
              onColHide={this.onSingleColumnHide.bind(this)}
              onHideAllColumn={this.onHideAllColumns.bind(this)}
            />
          ) : null}
        </div>
      </>
    );
  }
}
